import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import { getFrontendFunctionsBaseUrl } from '@src/config';
import creatorSdk from '@src/services/creator-sdk';
import { getPostsAtom } from '../posts/posts';
import { jotaiStore } from '../store';

export interface Flair {
    name: string;
    color: string;
    id: string;
}

export interface CreateFlairApiRequestPayload {
    tokenName: string;
    userId: string;
    flairColor: string;
    flairId: Flair['id'];
    flairName: Flair['name'];
}

export interface DeleteFlairApiRequestPayload {
    tokenName: string;
    userId: string;
    flairId: Flair['id'];
}

export interface AttachFlairApiRequestPayload {
    userId: string;
    postId: string;
    tokenName: string;
    flairIds: Flair['id'][]; // array of flair ids
}

export const createFlair = async (payload: CreateFlairApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Flair>>(
        '/flair/create',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false
    );
    return data;
};

export const deleteFlair = async (payload: DeleteFlairApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Flair>>(
        '/flair/delete',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false
    );
    return data;
};

export const attachFlair = async (payload: AttachFlairApiRequestPayload) => {
    const { postId, flairIds, tokenName } = payload;

    jotaiStore.set(getPostsAtom(), draft => {
        const post = draft[postId];
        if (!post) throw new Error(`[attachFlair] post with id ${postId} not found`);

        // Set multiple flairIds
        post.flairIds = flairIds;
    });

    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Flair>>(
        '/flair/attach',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false
    );

    // Temp fix
    const cacheKey = `partnerPosts_${tokenName}_*`;
    fetch(`${getFrontendFunctionsBaseUrl()}/cache?key=${cacheKey}`, { method: 'DELETE' });

    return data;
};
